module.exports = __webpack_public_path__ + "static/media/0110_LE_SOL_WOOD_SPIRIT_TEINTE_SPECIALE.b0cb12d3.png";